interface IProps {
    size?: number;
    color?: string;
}

export const BigLinkIcon = (props: IProps) => {
    const { size, color } = props;
    const defaultSize = "65";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 65 65"
            fill="none"
        >
            <path
                d="M33.3974 40.8066L27.583 46.6211C27.583 46.6211 27.583 46.6212 27.5829 46.6212C27.5829 46.6212 27.5829 46.6214 27.5828 46.6214C25.1784 49.0259 21.2659 49.026 18.8612 46.6214C17.6963 45.4564 17.0549 43.9076 17.0549 42.2604C17.0549 40.6134 17.6963 39.0648 18.8608 37.8999C18.8609 37.8998 18.861 37.8996 18.8612 37.8995L24.6755 32.085C25.4782 31.2822 25.4782 29.9805 24.6754 29.1778C23.8727 28.3751 22.571 28.3751 21.7681 29.1778L15.9538 34.9923C15.9534 34.9927 15.953 34.9932 15.9526 34.9936C14.0121 36.9348 12.9434 39.5156 12.9434 42.2604C12.9434 45.0059 14.0125 47.5871 15.9539 49.5286C17.9579 51.5324 20.5899 52.5344 23.2221 52.5344C25.8543 52.5344 28.4865 51.5324 30.4901 49.5286C30.4903 49.5286 30.4903 49.5283 30.4903 49.5283L36.3046 43.7138C37.1073 42.9111 37.1073 41.6094 36.3045 40.8066C35.5019 40.0039 34.2004 40.0039 33.3974 40.8066Z"
                fill={color || "#946037"}
            />
            <path
                d="M50.9453 24.8169C50.9453 22.0713 49.876 19.4901 47.9345 17.5487C43.9268 13.5411 37.4058 13.5412 33.3983 17.5487C33.3982 17.549 33.3979 17.5491 33.3978 17.5494L27.5836 23.3634C26.7807 24.1661 26.7807 25.468 27.5836 26.2707C27.9851 26.6722 28.5111 26.8729 29.0373 26.8729C29.5633 26.8729 30.0895 26.6721 30.4908 26.2707L36.305 20.4566C36.3052 20.4563 36.3054 20.4562 36.3057 20.4559C38.7101 18.0515 42.6226 18.0514 45.0273 20.4559C46.1921 21.6209 46.8338 23.1697 46.8338 24.8169C46.8338 26.4639 46.1924 28.0125 45.0277 29.1774L45.0273 29.1778L39.213 34.9923C38.4102 35.795 38.4102 37.0967 39.2131 37.8995C39.6145 38.3009 40.1406 38.5017 40.6666 38.5017C41.1928 38.5017 41.7189 38.3009 42.1203 37.8995L47.9347 32.085C47.9351 32.0846 47.9355 32.0841 47.9359 32.0837C49.8764 30.1425 50.9453 27.5617 50.9453 24.8169Z"
                fill={color || "#946037"}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.02546 20.7717C9.36852 19.4914 10.6845 18.7316 11.9649 19.0747L17.4283 20.5386C18.7086 20.8817 19.4684 22.1977 19.1253 23.478C18.7823 24.7583 17.4663 25.5181 16.186 25.1751L10.7225 23.7111C9.4422 23.3681 8.6824 22.0521 9.02546 20.7717Z"
                fill={color || "#946037"}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.7723 9.02532C22.0526 8.68226 23.3687 9.44206 23.7117 10.7224L25.1756 16.1858C25.5187 17.4661 24.7589 18.7821 23.4786 19.1252C22.1983 19.4683 20.8823 18.7085 20.5392 17.4281L19.0753 11.9647C18.7322 10.6844 19.492 9.36838 20.7723 9.02532Z"
                fill={color || "#946037"}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M55.9736 44.2283C55.6305 45.5086 54.3145 46.2684 53.0342 45.9253L47.5707 44.4614C46.2904 44.1183 45.5306 42.8023 45.8737 41.522C46.2167 40.2417 47.5327 39.4819 48.8131 39.8249L54.2765 41.2889C55.5568 41.6319 56.3166 42.9479 55.9736 44.2283Z"
                fill={color || "#946037"}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.2267 55.9747C42.9464 56.3177 41.6304 55.5579 41.2873 54.2776L39.8234 48.8142C39.4803 47.5339 40.2401 46.2179 41.5204 45.8748C42.8008 45.5317 44.1168 46.2915 44.4598 47.5719L45.9238 53.0353C46.2668 54.3156 45.507 55.6316 44.2267 55.9747Z"
                fill={color || "#946037"}
            />
        </svg>
    );
};
